// extracted by mini-css-extract-plugin
export default {"userTagWrapper":"index_userTagWrapper__azf1L","iconContainer":"index_iconContainer__tEH-6","nameContainer":"index_nameContainer__sStqg"};